module.exports = __webpack_public_path__ + "static/img/wild3.7c8be1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/wild3.png
// module id = LrHR
// module chunks = 0